(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[33],{

/***/ "54uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ACTIVATED; });
/* unused harmony export API_EDITABLE */
/* unused harmony export API_UNAVAILABLE */
/* unused harmony export API_NOTYET */
/* unused harmony export API_UNEDITABLE */
/* unused harmony export API_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_RESORT_ONLY; });
/* unused harmony export API_UPSELL_AVAILABLE */
/* unused harmony export API_RESORT_ONLY_FORM_SENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_DONE; });
var API_AVAILABLE = 'AVAILABLE';
var API_VALIDATED = 'VALIDATED';
var API_ACTIVATED = 'ACTIVATED';
var API_EDITABLE = 'EDITABLE';
var API_UNAVAILABLE = 'UNAVAILABLE';
var API_NOTYET = 'NOT_YET';
var API_UNEDITABLE = 'UNEDITABLE';
var API_OPTION = 'OPTION';
var API_RESORT_ONLY = 'RESORT_ONLY';
var API_RESORT_ONLY_FORM_SENT = 'RESORT_ONLY_FORM_SENT';
var API_UPSELL_AVAILABLE = 'UPSELL_AVAILABLE';
var API_DONE = 'DONE';


/***/ }),

/***/ "bGCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getProductUrlFromDestinationLine; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Product_mapper_getProductProps; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Product_mapper_getProductPriceInfoProps; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ setProductHref; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ Product_mapper_updateProductUrl; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_mapper_createProductUrlWithParams; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ updateProduct; });

// UNUSED EXPORTS: getProductTags, getProductOfferDiscountProps, getProductChildcareAvailabilitiesProps, getProductComparisonProps, getProductFlagProps, getProductHeaderProps, getProductPriceProps, getProductThumbnailProps

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// CONCATENATED MODULE: ./src/client/components/widgets/products-comparison/ProductsComparisonUtils.js



function getAggregateDiscount(product) {
  var proposals = get_default()(product, 'proposals.proposals', []);

  var selectedProposal = proposals.find(function (proposal) {
    return get_default()(proposal, 'selected', true);
  });
  return get_default()(selectedProposal, 'price.aggregateDiscount', null);
}


// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.mapper.js






















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var DEFAULT_COMPARISON = {
  isDisabled: false,
  isSelected: false
};

var getSubTitle = function getSubTitle(product) {
  var _product$destination;

  if (product.isCruise) {
    return product.timingDescription;
  }

  return ((_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country) || '';
};

var Product_mapper_getUrl = function getUrl(href, termsAndConditions) {
  var _termsAndConditions$d;

  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var departureDate = "".concat((termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.departureDate) || '');
  var url = new URI_default.a(href).setQuery({
    locale: queryParams === null || queryParams === void 0 ? void 0 : queryParams.locale,
    departure_city: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : (_termsAndConditions$d = termsAndConditions.departureCity) === null || _termsAndConditions$d === void 0 ? void 0 : _termsAndConditions$d.value,
    duration: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.duration,
    date: departureDate !== 'null' && departureDate ? Object(apiDate["g" /* formatApiDate */])(departureDate, constants["f" /* QUERY_DATE_FORMAT */]) : undefined
  });
  return url.toString();
};

var getProductUrl = function getProductUrl(props) {
  var _props$product$price;

  var isMice = !!props.product.mice;

  if (!props.contextualizeUrl) {
    return "".concat(isMice ? '/me' : '').concat(props.product.href);
  }

  var url = Product_mapper_getUrl(props.product.href, ((_props$product$price = props.product.price) === null || _props$product$price === void 0 ? void 0 : _props$product$price.termsAndConditions) || {});
  return "".concat(isMice ? '/me' : '').concat(url);
};

var getProductUrlFromDestinationLine = function getProductUrlFromDestinationLine(price, queryParams) {
  return Product_mapper_getUrl(price.productHref || '', price.termsAndConditions, queryParams);
};

var getProductHeaderProps = function getProductHeaderProps(props) {
  var product = props.product;
  var link = {
    url: getProductUrl(props)
  };
  var heading = {
    title: product.name,
    subtitle: getSubTitle(product)
  };
  return {
    heading: heading,
    link: link
  };
};

var Product_mapper_getProductComparisonProps = function getProductComparisonProps(_ref) {
  var _config$faceting;

  var _ref$comparison = _ref.comparison,
      comparison = _ref$comparison === void 0 ? DEFAULT_COMPARISON : _ref$comparison,
      config = _ref.config,
      product = _ref.product;

  var _ref2 = (config === null || config === void 0 ? void 0 : (_config$faceting = config.faceting) === null || _config$faceting === void 0 ? void 0 : _config$faceting.compare) || {},
      selected = _ref2.selected,
      selectResort = _ref2.selectResort,
      unavailableThumbnail = _ref2.unavailableThumbnail;

  var status = product_utils["b" /* IS_ENABLED */];

  if (comparison.isDisabled) {
    status = product_utils["a" /* IS_DISABLED */];
  } else if (comparison.isSelected) {
    status = product_utils["c" /* IS_SELECTED */];
  }

  var label = comparison.isSelected ? selected : selectResort;

  var _ref3 = product || {},
      isCruise = _ref3.isCruise,
      isTour = _ref3.isTour;

  return {
    status: status,
    label: label,
    isEligible: !isTour && !isCruise,
    eligibilityLabel: unavailableThumbnail
  };
};

var Product_mapper_getProductPriceProps = function getProductPriceProps(_ref4) {
  var _config$price;

  var config = _ref4.config,
      product = _ref4.product,
      _ref4$offer = _ref4.offer,
      offer = _ref4$offer === void 0 ? {} : _ref4$offer;
  var color = product.isJoyview ? colors["a" /* COLORS */].BLUE_WAVE : colors["a" /* COLORS */].SIENNA; // $FlowFixMe

  return _objectSpread(_objectSpread({
    style: {
      color: offer.color
    },
    color: offer.color || color
  }, (config === null || config === void 0 ? void 0 : (_config$price = config.price) === null || _config$price === void 0 ? void 0 : _config$price.format) || {}), product.price || product.mice || {});
};

var getChildCareAgeInMonths = function getChildCareAgeInMonths(_ref5) {
  var _product$childcareDet;

  var product = _ref5.product;

  if ((_product$childcareDet = product.childcareDetails) === null || _product$childcareDet === void 0 ? void 0 : _product$childcareDet.length) {
    return product.childcareDetails.map(function (_ref6) {
      var ageInMonths = _ref6.ageInMonths;
      return {
        ageInMonthsMin: ageInMonths.min,
        ageInMonthsMax: ageInMonths.max
      };
    });
  }
};

var Product_mapper_getProductChildcareAvailabilitiesProps = function getProductChildcareAvailabilitiesProps(_ref7) {
  var _config$faceting2;

  var config = _ref7.config,
      product = _ref7.product;

  var _ref8 = (config === null || config === void 0 ? void 0 : (_config$faceting2 = config.faceting) === null || _config$faceting2 === void 0 ? void 0 : _config$faceting2.availabilities) || {},
      monthsLabel = _ref8.months,
      yearsLabel = _ref8.years,
      yearLabel = _ref8.year,
      availableLabel = _ref8.available,
      unknownLabel = _ref8.unknown,
      unavailableLabel = _ref8.unavailable,
      urgentizationSingular = _ref8.urgentizationSingular,
      urgentizationPlural = _ref8.urgentizationPlural,
      childcareLabel = _ref8.childcare;

  var sortedChildcareAvailabilities = (product.childcareAvailabilities || []).sort(function (a, b) {
    return a.ageMin - b.ageMin;
  });

  var _sortedChildcareAvail = sortedChildcareAvailabilities,
      _sortedChildcareAvail2 = Object(slicedToArray["a" /* default */])(_sortedChildcareAvail, 2),
      _sortedChildcareAvail3 = _sortedChildcareAvail2[0],
      first = _sortedChildcareAvail3 === void 0 ? {} : _sortedChildcareAvail3,
      _sortedChildcareAvail4 = _sortedChildcareAvail2[1],
      second = _sortedChildcareAvail4 === void 0 ? {} : _sortedChildcareAvail4;

  var hasChildBetween4And23Months = first.ageMin === 4 || first.ageMax === 23;
  var hasOnlyBetween4And13Months = first.ageMin === 4 && second.ageMax !== 23;
  var hasOnlyBetween14And23Months = first.ageMax === 23;

  if (hasOnlyBetween4And13Months) {
    first.ageMax = 23;
  } else if (hasOnlyBetween14And23Months) {
    first.ageMin = 4;
  } else if (hasChildBetween4And23Months) {
    var stock = first.remainingStock === null && second.remainingStock === null ? null : (first.remainingStock || 0) + (second.remainingStock || 0);
    var availability = 'UNKNOWN';

    if (stock === 0) {
      availability = 'UNAVAILABLE';
    } else if (stock) {
      availability = stock <= 10 ? 'PARTIAL' : 'AVAILABLE';
    }

    sortedChildcareAvailabilities = [_objectSpread(_objectSpread({}, second), {}, {
      remainingStock: stock,
      ageMin: 4,
      ageMax: 23,
      availability: availability
    })].concat(Object(toConsumableArray["a" /* default */])(sortedChildcareAvailabilities.slice(2)));
  }

  return {
    items: sortedChildcareAvailabilities,
    monthsLabel: monthsLabel,
    yearsLabel: yearsLabel,
    yearLabel: yearLabel,
    availableLabel: availableLabel,
    unavailableLabel: unavailableLabel,
    unknownLabel: unknownLabel,
    remainingLabel: {
      n: urgentizationPlural,
      _1: urgentizationSingular
    },
    childcareLabel: childcareLabel
  };
};

var Product_mapper_getProductPriceInfoProps = function getProductPriceInfoProps(_ref9) {
  var _config$resort, _config$resort$starti, _product$price, _product$price$termsA, _product$price2, _product$price2$terms, _product$price3, _product$price3$terms, _product$price4, _product$price4$terms, _product$price4$terms2, _product$price5, _product$price5$terms, _product$price5$terms2, _product$price6, _product$price6$terms, _product$price7, _product$mice;

  var config = _ref9.config,
      product = _ref9.product;
  var startDate = '';
  var endDate = '';
  var dateFormat = (config === null || config === void 0 ? void 0 : (_config$resort = config.resort) === null || _config$resort === void 0 ? void 0 : (_config$resort$starti = _config$resort.startingPrice) === null || _config$resort$starti === void 0 ? void 0 : _config$resort$starti.dateFormat) || Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  startDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$termsA = _product$price.termsAndConditions) === null || _product$price$termsA === void 0 ? void 0 : _product$price$termsA.departureDate, apiDate["a" /* API_DATE_FORMAT */]).format(dateFormat);
  endDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$terms = _product$price2.termsAndConditions) === null || _product$price2$terms === void 0 ? void 0 : _product$price2$terms.departureDate, apiDate["a" /* API_DATE_FORMAT */]).add({
    days: ((_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : (_product$price3$terms = _product$price3.termsAndConditions) === null || _product$price3$terms === void 0 ? void 0 : _product$price3$terms.duration) || 0
  }).format(dateFormat);
  return {
    city: (product === null || product === void 0 ? void 0 : (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : (_product$price4$terms = _product$price4.termsAndConditions) === null || _product$price4$terms === void 0 ? void 0 : (_product$price4$terms2 = _product$price4$terms.departureCity) === null || _product$price4$terms2 === void 0 ? void 0 : _product$price4$terms2.name) || '',
    endDate: endDate,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : (_product$price5$terms = _product$price5.termsAndConditions) === null || _product$price5$terms === void 0 ? void 0 : (_product$price5$terms2 = _product$price5$terms.departureCity) === null || _product$price5$terms2 === void 0 ? void 0 : _product$price5$terms2.value),
    isCruise: product.isCruise,
    isJoyview: product.isJoyview,
    isTour: product.isTour,
    rate: product === null || product === void 0 ? void 0 : (_product$price6 = product.price) === null || _product$price6 === void 0 ? void 0 : (_product$price6$terms = _product$price6.termsAndConditions) === null || _product$price6$terms === void 0 ? void 0 : _product$price6$terms.offerId,
    startDate: startDate,
    transportIcon: product.transportType,
    unit: ((_product$price7 = product.price) === null || _product$price7 === void 0 ? void 0 : _product$price7.unit) || ((_product$mice = product.mice) === null || _product$mice === void 0 ? void 0 : _product$mice.unit) || ''
  };
};

var Product_mapper_getTopTags = function getTopTags(_ref10) {
  var _product$price8, _product$price8$terms, _product$price8$terms2;

  var hasTransport = _ref10.hasTransport,
      product = _ref10.product;
  var openingStatus = product.openingStatus,
      tags = product.tags;
  var hasDepartureCity = Boolean(product === null || product === void 0 ? void 0 : (_product$price8 = product.price) === null || _product$price8 === void 0 ? void 0 : (_product$price8$terms = _product$price8.termsAndConditions) === null || _product$price8$terms === void 0 ? void 0 : (_product$price8$terms2 = _product$price8$terms.departureCity) === null || _product$price8$terms2 === void 0 ? void 0 : _product$price8$terms2.value);
  var isOpeningSoon = openingStatus === OPENING_STATUS.OPENING_SOON;
  var priorityTagslength = hasDepartureCity + isOpeningSoon + !!product.seasonTrad;

  var productTopTags = Object(toConsumableArray["a" /* default */])((tags || []).slice(0, 3 - priorityTagslength).map(function (tag, i) {
    return {
      dataTestId: "ProductThumbnail-tag-".concat(i),
      label: tag.title,
      style: {
        backgroundColor: tag.backgroundColor,
        borderColor: tag.backgroundColor,
        color: tag.textColor
      }
    };
  }));

  if (product.seasonTrad) {
    productTopTags.push({
      className: 'text-white border-turquoise bg-turquoise',
      dataTestId: 'ProductThumbnail-seasonBadge',
      label: product.seasonTrad
    });
  }

  if (hasDepartureCity || hasTransport) {
    productTopTags.push({
      dataTestId: 'ProductThumbnail-transport',
      iconName: product.transportType,
      label: Object(i18n["h" /* t */])('price.format.flightIncluded')
    });
  }

  if (isOpeningSoon) {
    productTopTags.push({
      className: 'text-white border-orange bg-orange',
      dataTestId: 'ProductThumbnail-openingSoon',
      label: Object(i18n["h" /* t */])('common.openingSoon')
    });
  }

  return productTopTags;
};

var Product_mapper_getProductTags = function getProductTags(product) {
  var productTags = [];

  if (product.mice) {
    var _product$productMeeti, _product$productMeeti2, _product$accommodatio;

    var maxConferenceRoomCapacity = (_product$productMeeti = product.productMeetingRooms) === null || _product$productMeeti === void 0 ? void 0 : (_product$productMeeti2 = _product$productMeeti.meetingRooms) === null || _product$productMeeti2 === void 0 ? void 0 : _product$productMeeti2.reduce(function (roomMaxCapacity, _ref11) {
      var shapes = _ref11.shapes;
      return Math.max(roomMaxCapacity, shapes.reduce(function (maxShape, _ref12) {
        var maxCapacity = _ref12.maxCapacity;
        return Math.max(maxCapacity, maxShape);
      }, 0));
    }, 0);

    if (maxConferenceRoomCapacity) {
      productTags.push({
        className: 'text-sienna bg-white border-white',
        label: Object(i18n["h" /* t */])('common.conferenceRoomCapacity', {
          maxConferenceRoomCapacity: maxConferenceRoomCapacity
        })
      });
    }

    if ((_product$accommodatio = product.accommodationsIntroduction) === null || _product$accommodatio === void 0 ? void 0 : _product$accommodatio.roomsCount) {
      productTags.push({
        className: 'text-sienna border-white bg-white',
        label: Object(i18n["h" /* t */])('common.numberOfRooms', {
          numberOfRooms: product.accommodationsIntroduction.roomsCount
        })
      });
    }

    return productTags;
  }

  if (product.isTour) {
    var _product$rangeLabel;

    var rangeLabel = (_product$rangeLabel = product.rangeLabel) === null || _product$rangeLabel === void 0 ? void 0 : _product$rangeLabel.toUpperCase();
    return [{
      className: 'text-white border-sienna bg-sienna',
      label: product.duration ? "".concat(rangeLabel, " : ").concat(product.duration) : rangeLabel
    }];
  }

  if (product.isCruise) {
    var _product$thematics, _product$thematics$;

    var label = [(_product$thematics = product.thematics) === null || _product$thematics === void 0 ? void 0 : (_product$thematics$ = _product$thematics[0]) === null || _product$thematics$ === void 0 ? void 0 : _product$thematics$.label, product.duration].filter(Boolean).join(' - ');
    return [{
      className: 'text-white border-ultramarine bg-ultramarine',
      label: label
    }];
  }

  if (product.hasECSpace) {
    return [{
      className: 'text-ultramarine border-white bg-white',
      iconName: icons["a" /* ICONS */].DIAMOND,
      label: Object(i18n["h" /* t */])('common.product.exclusiveCollectionSpaceTag')
    }];
  }

  if (product.isExplicitEC) {
    return [{
      className: 'text-ultramarine border-white bg-white',
      iconName: icons["a" /* ICONS */].DIAMOND,
      label: Object(i18n["h" /* t */])('common.product.exclusiveCollectionTag')
    }];
  }
};

var Product_mapper_getProductThumbnailProps = function getProductThumbnailProps(props) {
  var product = props.product,
      _props$isSliderDisabl = props.isSliderDisabled,
      isSliderDisabled = _props$isSliderDisabl === void 0 ? false : _props$isSliderDisabl;
  var openingStatus = product.openingStatus;
  return {
    bottomTags: Product_mapper_getProductTags(product),
    closedLabel: Object(i18n["h" /* t */])('common.closed'),
    isSliderDisabled: isSliderDisabled,
    link: {
      url: getProductUrl(props)
    },
    openingStatus: openingStatus,
    pictures: (product.images || []).map(function (image) {
      return {
        alt: product.name,
        src: image || ''
      };
    }),
    topTags: Product_mapper_getTopTags(props)
  };
};

var getProductFlagProps = function getProductFlagProps(props) {
  var _props$isPriceLoading = props.isPriceLoading,
      isPriceLoading = _props$isPriceLoading === void 0 ? false : _props$isPriceLoading,
      product = props.product;
  var _product$openingStatu = product.openingStatus,
      openingStatus = _product$openingStatu === void 0 ? OPENING_STATUS.OPEN : _product$openingStatu;
  var price = openingStatus === OPENING_STATUS.OPEN ? Product_mapper_getProductPriceProps(props) : {};
  return {
    price: price,
    priceInfo: Product_mapper_getProductPriceInfoProps(props),
    isPriceLoading: isPriceLoading
  };
};

var Product_mapper_getProductOfferDiscountProps = function getProductOfferDiscountProps(_ref13) {
  var product = _ref13.product,
      config = _ref13.config;
  return {
    discount: getAggregateDiscount(product),
    i18n: config.offerDiscount
  };
};

var Product_mapper_createProductUrlWithParams = function createProductUrlWithParams(href, product) {
  var currentLocation = dist["windowWrapper"].getLocation();
  var possibleQueries = [constants["g" /* QUERY_DEPARTURE_DATE */], constants["h" /* QUERY_DURATION */], constants["m" /* QUERY_TRANSPORT */], constants["j" /* QUERY_KIDS */]];

  if (product.isCruise) {
    possibleQueries = [constants["m" /* QUERY_TRANSPORT */]];
  } else if (product.isTour) {
    possibleQueries = [constants["g" /* QUERY_DEPARTURE_DATE */], constants["m" /* QUERY_TRANSPORT */]];
  }

  var getDepartureDate = function getDepartureDate() {
    var _product$flag, _product$flag$price, _product$flag$price$t; // $FlowFixMe


    if (product.departureDateOn && (product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : (_product$flag$price = _product$flag.price) === null || _product$flag$price === void 0 ? void 0 : (_product$flag$price$t = _product$flag$price.termsAndConditions) === null || _product$flag$price$t === void 0 ? void 0 : _product$flag$price$t.departureDate)) {
      return Object(apiDate["j" /* momentFromApiDate */])(product.flag.price.termsAndConditions.departureDate).format(constants["f" /* QUERY_DATE_FORMAT */]);
    }

    return Object(uriUtils["j" /* getQueryParameters */])(currentLocation)[constants["g" /* QUERY_DEPARTURE_DATE */]] || '';
  };

  return Object(uriUtils["f" /* generateUrlWithParams */])(href, {
    queryParams: possibleQueries.reduce(function (acc, curr) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, curr, curr === constants["g" /* QUERY_DEPARTURE_DATE */] ? getDepartureDate() : Object(uriUtils["j" /* getQueryParameters */])(currentLocation)[curr] || ''));
    }, // $FlowFixMe
    {})
  });
};

var setProductHref = function setProductHref(props) {
  var _props$product = props.product,
      product = _props$product === void 0 ? {} : _props$product;
  var href = product.href;

  if (href && true) {
    return _objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      product: _objectSpread(_objectSpread({}, product), {}, {
        href: Product_mapper_createProductUrlWithParams(href, product)
      })
    });
  }

  return props;
};

var Product_mapper_getProductProps = function getProductProps(props) {
  var _props$product3, _props$product3$child, _product$destination2;

  var _props$hasComparison = props.hasComparison,
      hasComparison = _props$hasComparison === void 0 ? false : _props$hasComparison,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      _props$offer = props.offer,
      offer = _props$offer === void 0 ? {} : _props$offer,
      _props$product2 = props.product,
      product = _props$product2 === void 0 ? {} : _props$product2;
  var flag = getProductFlagProps(props);
  var flagPrice = flag.price || {};
  var matchingOfferProducts = offer.products && offer.products.length > 0 ? offer.products.filter(function (offerProduct) {
    return offerProduct.id === product.id;
  }) : [];
  var price = matchingOfferProducts.length === 1 ? matchingOfferProducts.map(function (matchingOfferProduct) {
    return matchingOfferProduct.price;
  }).shift() : flagPrice;
  return {
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    childcareAgeInMonths: getChildCareAgeInMonths(props),
    childcareIncluded: (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : (_props$product3$child = _props$product3.childcareDetails) === null || _props$product3$child === void 0 ? void 0 : _props$product3$child.some(function (childcare) {
      return childcare.included;
    }),
    comfort: product.comfort,
    comparison: Product_mapper_getProductComparisonProps(props),
    coordinates: product.coordinates,
    departureDateOn: product.departureDateOn,
    flag: flag,
    hasComparison: hasComparison,
    header: getProductHeaderProps(props),
    id: product.id,
    isCruise: product.isCruise,
    isTour: product.isTour,
    kids: kids,
    minAuthorizedAge: props.product.minAuthorizedAge,
    price: !isEmpty_default()(price) ? price : undefined,
    resortRegion: (_product$destination2 = product.destination) === null || _product$destination2 === void 0 ? void 0 : _product$destination2.area,
    thumbnail: Product_mapper_getProductThumbnailProps(props),
    type: product.type,
    url: getProductUrl(props)
  };
};

var updateProduct = function updateProduct(product, props) {
  return _objectSpread(_objectSpread({}, product), {}, {
    hasComparison: props.hasComparison,
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    comparison: Product_mapper_getProductComparisonProps(props),
    flag: getProductFlagProps(props)
  });
};

var Product_mapper_updateProductUrl = function updateProductUrl(product) {
  var newProductUrl = Product_mapper_createProductUrlWithParams(new URI_default.a(product.url).pathname(), product);
  return _objectSpread(_objectSpread({}, product), {}, {
    url: newProductUrl,
    header: _objectSpread(_objectSpread({}, product.header), {}, {
      link: {
        url: newProductUrl
      }
    }),
    // $FlowFixMe
    thumbnail: _objectSpread(_objectSpread({}, product.thumbnail), {}, {
      link: {
        url: newProductUrl
      }
    })
  });
};



/***/ }),

/***/ "w04c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductsGrid_ProductsGrid; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 1 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 5 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var constants = __webpack_require__("54uq");

// CONCATENATED MODULE: ./src/utils/products/productsUtils.js







function sortProductsByPriceAsc(_ref, _ref2) {
  var _priceA$bestPrice, _priceB$bestPrice;

  var priceA = _ref.price;
  var priceB = _ref2.price; // equal items sort equally

  if ((priceA === null || priceA === void 0 ? void 0 : (_priceA$bestPrice = priceA.bestPrice) === null || _priceA$bestPrice === void 0 ? void 0 : _priceA$bestPrice.value) === (priceB === null || priceB === void 0 ? void 0 : (_priceB$bestPrice = priceB.bestPrice) === null || _priceB$bestPrice === void 0 ? void 0 : _priceB$bestPrice.value)) {
    return 0;
  } // nulls sort after anything else


  if (!(priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice)) {
    return 1;
  }

  if (!(priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice)) {
    return -1;
  }

  return (priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice.value) < (priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice.value) ? -1 : 1;
}

function sortProductsByPriceDesc(_ref3, _ref4) {
  var _priceA$bestPrice2, _priceB$bestPrice2;

  var priceA = _ref3.price;
  var priceB = _ref4.price; // equal items sort equally

  if ((priceA === null || priceA === void 0 ? void 0 : (_priceA$bestPrice2 = priceA.bestPrice) === null || _priceA$bestPrice2 === void 0 ? void 0 : _priceA$bestPrice2.value) === (priceB === null || priceB === void 0 ? void 0 : (_priceB$bestPrice2 = priceB.bestPrice) === null || _priceB$bestPrice2 === void 0 ? void 0 : _priceB$bestPrice2.value)) {
    return 0;
  } // nulls sort after anything else


  if (!(priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice)) {
    return 1;
  }

  if (!(priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice)) {
    return -1;
  }

  return (priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice.value) < (priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice.value) ? 1 : -1;
}

function sortProductsByPrice(products, orderByPrice) {
  var sortFunction = orderByPrice === 'asc' ? sortProductsByPriceAsc : sortProductsByPriceDesc;
  return Object(toConsumableArray["a" /* default */])(products).sort(sortFunction);
}

function sortProductsByChildcareAvailabilityDesc(productA, productB) {
  var _productA$childcare, _productB$childcare;

  var numberOfChildcaresWithBestAvailabilityA = 0;
  var childcareItemsA = (productA === null || productA === void 0 ? void 0 : (_productA$childcare = productA.childcare) === null || _productA$childcare === void 0 ? void 0 : _productA$childcare.items) || [];

  if (childcareItemsA.length > 0) {
    childcareItemsA.forEach(function (_ref5) {
      var availability = _ref5.availability,
          isIncluded = _ref5.isIncluded,
          remainingStock = _ref5.remainingStock;

      if (remainingStock === null) {
        if (isIncluded && availability === constants["b" /* API_AVAILABLE */]) {
          numberOfChildcaresWithBestAvailabilityA++;
        }
      } else if (remainingStock >= 10) {
        numberOfChildcaresWithBestAvailabilityA++;
      }
    });
  }

  var numberOfChildcaresWithBestAvailabilityB = 0;
  var childcareItemsB = (productB === null || productB === void 0 ? void 0 : (_productB$childcare = productB.childcare) === null || _productB$childcare === void 0 ? void 0 : _productB$childcare.items) || [];

  if (childcareItemsB.length > 0) {
    childcareItemsB.forEach(function (_ref6) {
      var availability = _ref6.availability,
          isIncluded = _ref6.isIncluded,
          remainingStock = _ref6.remainingStock;

      if (remainingStock === null) {
        if (isIncluded && availability === constants["b" /* API_AVAILABLE */]) {
          numberOfChildcaresWithBestAvailabilityB++;
        }
      } else if (remainingStock >= 10) {
        numberOfChildcaresWithBestAvailabilityB++;
      }
    });
  }

  if (numberOfChildcaresWithBestAvailabilityA === numberOfChildcaresWithBestAvailabilityB) {
    return 0;
  }

  return numberOfChildcaresWithBestAvailabilityA < numberOfChildcaresWithBestAvailabilityB ? 1 : -1;
}

function sortProductsByChildcareAvailability(products, orderByPrice) {
  var productsWithBestChildcareAvailability = [];
  var productsWithChildcareAvailability = [];
  var productsWithMissingChildcareAvailability = [];
  products.forEach(function (product) {
    var _product$childcare;

    var remainingStockGreaterOrEqualTo10Count = 0;
    var unavailableCount = 0;
    var childcareItems = (product === null || product === void 0 ? void 0 : (_product$childcare = product.childcare) === null || _product$childcare === void 0 ? void 0 : _product$childcare.items) || [];

    if (childcareItems.length > 0) {
      childcareItems.forEach(function (_ref7) {
        var availability = _ref7.availability,
            isIncluded = _ref7.isIncluded,
            remainingStock = _ref7.remainingStock;

        if (remainingStock === null) {
          if (isIncluded && availability === constants["b" /* API_AVAILABLE */]) {
            remainingStockGreaterOrEqualTo10Count++;
          } else {
            unavailableCount++;
          }
        } else if (remainingStock >= 10) {
          remainingStockGreaterOrEqualTo10Count++;
        } else if (remainingStock === 0) {
          unavailableCount++;
        }
      });
    } else {
      unavailableCount++;
    }

    if (unavailableCount > 0) {
      productsWithMissingChildcareAvailability.push(product);
    } else if (remainingStockGreaterOrEqualTo10Count === childcareItems.length) {
      productsWithBestChildcareAvailability.push(product);
    } else {
      productsWithChildcareAvailability.push(product);
    }
  });
  return orderByPrice ? [].concat(Object(toConsumableArray["a" /* default */])(sortProductsByPrice(productsWithBestChildcareAvailability, orderByPrice)), Object(toConsumableArray["a" /* default */])(sortProductsByPrice(productsWithChildcareAvailability, orderByPrice)), Object(toConsumableArray["a" /* default */])(sortProductsByPrice(productsWithMissingChildcareAvailability, orderByPrice))) : [].concat(productsWithBestChildcareAvailability, Object(toConsumableArray["a" /* default */])(productsWithChildcareAvailability.sort(sortProductsByChildcareAvailabilityDesc)), Object(toConsumableArray["a" /* default */])(productsWithMissingChildcareAvailability.sort(sortProductsByChildcareAvailabilityDesc)));
}


// CONCATENATED MODULE: ./src/client/components/widgets/products-grid/ProductsGrid.jsx


var __jsx = react_default.a.createElement;






var ProductsGrid_ProductsGrid = function ProductsGrid(_ref) {
  var childrenClassName = _ref.childrenClassName,
      className = _ref.className,
      display = _ref.display,
      fetchData = _ref.fetchData,
      grid = _ref.grid,
      hasSeeMore = _ref.hasSeeMore,
      isLoading = _ref.isLoading,
      _ref$isSynchronousGri = _ref.isSynchronousGrid,
      isSynchronousGrid = _ref$isSynchronousGri === void 0 ? false : _ref$isSynchronousGri,
      lineName = _ref.lineName,
      offer = _ref.offer,
      onComparisonClick = _ref.onComparisonClick,
      _ref$orderByChildcare = _ref.orderByChildcareAvailability,
      orderByChildcareAvailability = _ref$orderByChildcare === void 0 ? false : _ref$orderByChildcare,
      orderByPrice = _ref.orderByPrice,
      products = _ref.products,
      seeMore = _ref.seeMore,
      totalNumberToDisplay = _ref.totalNumberToDisplay;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (products.length === 0) {
    return null;
  }

  var cmtaLinks = Object(dist["getCmtaLinks"])(appContext.locale);
  var productListSorted;

  if (orderByChildcareAvailability) {
    productListSorted = sortProductsByChildcareAvailability(products, orderByPrice);
  } else {
    productListSorted = orderByPrice ? sortProductsByPrice(products, orderByPrice) : products;
  }

  return __jsx(Grid["a" /* default */], {
    className: className,
    childrenClassName: childrenClassName,
    display: display || grid,
    getChildren: fetchData,
    grid: grid,
    hasSeeMore: hasSeeMore,
    isLoading: isLoading,
    seeMore: seeMore,
    totalNumberToDisplay: totalNumberToDisplay,
    isSynchronousGrid: isSynchronousGrid
  }, productListSorted.map(function (product, index) {
    return __jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      cmtaLinks: cmtaLinks,
      index: index,
      key: product.id,
      lineName: lineName,
      offer: offer,
      onComparisonClick: onComparisonClick ? function () {
        return onComparisonClick(product.id);
      } : undefined
    }, product));
  }));
};
ProductsGrid_ProductsGrid.defaultProps = {
  hasSeeMore: false,
  products: []
};

/***/ })

}]);